import React, { useState } from 'react';
import Popup from '@techsoftware/happay-widgets/Popup';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import { currencyFormatter } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';

export default function OverLimitPaymentIntimation({ limit = {}, currency }) {
  const {
    available = 0,
    scheduled_payment: schedulePayment = 0,
    invoiceAmount = 0,
  } = limit;
  const [popup, setPopup] = useState(false);
  const remainingbalance = available - schedulePayment + invoiceAmount;
  return remainingbalance > 0 ? (
    <div></div>
  ) : (
    <div className="pos-relative flex-center">
      <span className="font-14 fw-600 body">
        Remaining Credit:{' '}
        <span className="alert-red-color fw-500 margin-r-6">
          {currencyFormatter(available - schedulePayment, currency)}
        </span>
      </span>
      <Popup
        id="overlimit-payment-info-popup"
        open={popup}
        border
        popupStyle={{ top: 30, left: 10 }}
        variant="scroll"
        onMouseEnter={event => setPopup(true)}
        onMouseLeave={event => setPopup(false)}
        parentElement={
          <Icons
            type="info"
            size="medium"
            className="alert-red-color pointer padding-t-5"
          />
        }
        pointerPlacement="top-center"
        borderStyle="1px solid #eb4646"
      >
        <div className="padding-16 font-12 body width-285">
          You have no credit balance available to make this payment.
          <br />
          <br />
          Please ensure that a sufficient balance is available to avoid payment
          failure.
        </div>
      </Popup>
    </div>
  );
}
